// Scripting of modals and interactions
(function ($) {
    $(document).on('click', 'a.open-popup-link, .open-popup-link > a', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (!$(this).hasClass('mp-init')) {
            var $modal = $($(this).attr('href')).first();
            var hasVideo = $modal.find('iframe');

            $(this).magnificPopup({
                type: 'inline',
                // modal: true,
                closeOnBgClick: true,
                closeOnContentClick: false,
                showCloseBtn: true,
                closeBtnInside: true,
                enableEscapeKey: true,
                callbacks: {
                    open: function () {
                        if (hasVideo) {
                            $modal.find(".wp-has-aspect-ratio iframe").each(function () {
                                var addautoplay = $(this).attr("src") + "?autoplay=1";
                                $(this).attr("src", addautoplay);
                            });
                        }
                    },
                    close: function () {
                        if (hasVideo) {
                            $modal.find(".wp-has-aspect-ratio iframe").each(function () {
                                var removeautoplay = $(this).attr("src").replace("?autoplay=1", "");
                                $(this).attr("src", removeautoplay);
                            });
                        }
                    }
                }
            }).addClass('mp-init').click();
        }
    });

    //Open the popup from the url, if it exists
    if (window.location.hash && $(window.location.hash).length) {

        // If popup class is on the target, pop it like its hot.
        if ($(window.location.hash).hasClass('standard-modal')) {
            var $modal = $(window.location.hash);
            var hasVideo = $modal.find('iframe');

            $.magnificPopup.open({
                items: {
                    src: window.location.hash,
                },
                type: 'inline',
                closeOnBgClick: true,
                closeOnContentClick: false,
                showCloseBtn: true,
                closeBtnInside: true,
                enableEscapeKey: true,
                callbacks: {
                    open: function () {
                        if (hasVideo) {
                            $modal.find(".wp-has-aspect-ratio iframe").each(function () {
                                var addautoplay = $(this).attr("src") + "?autoplay=1";
                                $(this).attr("src", addautoplay);
                            });
                        }
                    },
                    close: function () {
                        if (hasVideo) {
                            $modal.find(".wp-has-aspect-ratio iframe").each(function () {
                                var removeautoplay = $(this).attr("src").replace("?autoplay=1", "");
                                $(this).attr("src", removeautoplay);
                            });
                        }
                    }
                }
            });
        }
    }

// TEAM MEMBER MODAL
  $('.featured-team-member > .team-member-wrapper').each(function() {
    $(this).magnificPopup({
        type: 'inline',
        // Delay in milliseconds before popup is removed
        removalDelay: 300,

        // Class that is added to popup wrapper and background
        // make it unique to apply your CSS animations just to this exact popup
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeOnContentClick: false,
        showCloseBtn: true,
        closeBtnInside: true,
        enableEscapeKey: false,
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
            open: function() {
                $('body').addClass('modal-open');
            },
            close: function() {
                $('body').removeClass('modal-open');
            }
        },
        items: [
            {
                src: '#'+$(this).attr('data-team-member'),
                type: 'inline'
            }
        ],
    });
  });


})(jQuery);
